function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useEffect } from 'react';
import withRender from '../../hoc/withRender';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { journeyDeselectStart, navitiaSearch, navitiaSuggest } from '../../store/actions/navitiaSearch';
import NavitiaSearchBoxComponent from '../../components/NavitiaSearch/NavitiaSearchBox';
import { getHash, setHash } from '../../utils/urlUtils';
var NavitiaSearchBox = function NavitiaSearchBox(props) {
  var dispatch = useDispatch();
  var _useSelector = useSelector(function (state) {
      var _state$dataset;
      return state === null || state === void 0 ? void 0 : (_state$dataset = state.dataset) === null || _state$dataset === void 0 ? void 0 : _state$dataset.navitiaSearch;
    }),
    text = _useSelector.text,
    journeys = _useSelector.journeys,
    loading = _useSelector.loading,
    error = _useSelector.error;
  useEffect(function () {
    var journeyHash = getHash('journey');
    if (journeyHash) {
      var getFromTo = journeyHash.split('&').reduce(function (res, item) {
        var parts = item.split('=');
        res[parts[0]] = parts[1];
        return res;
      }, []);
      var fromCoord = decodeURIComponent(getFromTo.from);
      var toCoord = decodeURIComponent(getFromTo.to);
      handleSearch(fromCoord, toCoord);
    }
  }, []);
  var handleSearch = function handleSearch(fromValue, toValue) {
    setHash('journey', "from=" + fromValue + "&to=" + toValue);
    dispatch(navitiaSearch(fromValue, toValue));
  };
  var handleRemove = function handleRemove() {
    setHash('journey', '');
    dispatch(journeyDeselectStart());
  };
  return /*#__PURE__*/React.createElement(NavitiaSearchBoxComponent, _extends({
    text: text,
    journeys: journeys,
    loading: loading,
    error: error,
    onSubmit: function onSubmit(from, to) {
      return handleSearch(from, to);
    },
    onUpdate: function onUpdate(value, addressLimit, stopAreaLimit) {
      dispatch(navitiaSuggest(value, addressLimit, stopAreaLimit));
    },
    onRemove: handleRemove
  }, props));
};
NavitiaSearchBox.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.func.isRequired
} : {};
export default withRender(NavitiaSearchBox);